const resources = {
    new: 'new',
    signIn: 'Sign in',
    signInToAdd: ' to to add or view your Beauty Preferences.',
    infoModalTitle: 'Beauty Preferences',
    infoModalMessage: 'Shop with personalized filters from your ',
    infoModalMessageEndLink: 'Beauty Preferences.',
    gotIt: 'Got It',
    applyFilters: 'Apply filters to set your Beauty Preferences.',
    selectAll: 'Select All',
    deselectAll: 'Deselect All'
};

export default function getResource(label) {
    return resources[label];
}
